export default __webpack_public_path__ + "static/media/close_custom_ant_modal.c4732d65.svg";